import { UserLogInterface } from './../../../interfaces/user';
import { RequestFloatTransferComponent } from './../request-float-transfer/request-float-transfer.component';
import { Component, ElementRef, OnInit, Renderer2 } from '@angular/core';
import { Menu, NavService } from '../../services/nav.service';
import { NavigationEnd, Router } from '@angular/router';
import { filter, map } from 'rxjs';
import { LogoutDialogComponent } from '../logout-dialog/logout-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { AuthService } from '../../../service/auth.service';
import swal from 'sweetalert';
import { CofirmationDialogComponent } from '../cofirmation-dialog/cofirmation-dialog.component';
import { DeveloperKeysComponent } from '../developer-keys/developer-keys.component';
import { unsubscribe } from 'diagnostics_channel';
import { BalanceSheetService } from '../../../service/account/balance-sheet.service';
import { TranslationService } from '../../../service/translation.service';
import { TranslationObj } from '../../../interfaces/translation';
import { TranslateService } from '@ngx-translate/core';
interface Item {
  id: number;
  name: string; 
  type: string;
  title: string;
  // Add other properties as needed
}
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  public activeTabId = 0;
  cartItemCount: number = 5;
  notificationCount: number = 5;
  public user: any = null;
  public isCollapsed = true;
  currentRoute: string = '';
  constructor(
    public navServices: NavService,
    private elementRef: ElementRef,
    private renderer: Renderer2,
    private dialog: MatDialog,
    private router: Router,
    private authService: AuthService,
    private balanceSheetService: BalanceSheetService,
    private translationService: TranslationService,
    private translate: TranslateService
  ) {}
  isFullScreen = false;
  fullScreenIconVisible = true;
  exitFullScreenIconVisible = false;
  userLogData!: UserLogInterface;
  public languages: TranslationObj[] = this.translationService.getLanguagesObj();
  public selectedLanguage!: TranslationObj;

  toggleFullScreen() {
    this.isFullScreen = !this.isFullScreen;
    this.fullScreenIconVisible = !this.isFullScreen;
    this.exitFullScreenIconVisible = this.isFullScreen;
  }
  themeChange(type: string, type1: string, type2: string) {
    this.elementRef.nativeElement.ownerDocument.documentElement?.setAttribute(
      'class',
      type
    );
    this.elementRef.nativeElement.ownerDocument.documentElement?.setAttribute(
      'style',
      ''
    );
    localStorage.removeItem('ynex-background-mode-body');
    localStorage.removeItem('ynex-background-mode-dark');
    localStorage.setItem('ynex-theme-mode', type);
    this.elementRef.nativeElement.ownerDocument.documentElement?.setAttribute(
      'data-header-styles',
      type1
    );
    localStorage.setItem('ynex-header-mode', type1);
    this.elementRef.nativeElement.ownerDocument.documentElement?.setAttribute(
      'data-menu-styles',
      type2
    );
    localStorage.setItem('ynex-menu-mode', type2);
    const htmlElement =
      this.elementRef.nativeElement.ownerDocument.documentElement;

    if (type == 'dark') {
      const darkbtn = document.querySelector(
        '#switcher-dark-theme'
      ) as HTMLInputElement;
      darkbtn.checked = true;
      this.renderer.setAttribute(htmlElement, 'data-menu-style', 'dark');
    } else {
      const lightbtn = document.querySelector(
        '#switcher-light-theme'
      ) as HTMLInputElement;
      lightbtn.checked = true;
      this.renderer.setAttribute(htmlElement, 'data-menu-style', 'light');
    }
  }
  toggleSidebar() {
    let html = this.elementRef.nativeElement.ownerDocument.documentElement;
    // const windowObject: any = window;
    if (localStorage.getItem('data-toggled') == 'true') {
      document.querySelector('html')?.getAttribute('data-toggled') ==
        'icon-overlay-close';
    } else if (html?.getAttribute('data-vertical-style') == 'overlay') {
      document.querySelector('html')?.getAttribute('data-toggled') != null
        ? document.querySelector('html')?.removeAttribute('data-toggled')
        : document
            .querySelector('html')
            ?.setAttribute('data-toggled', 'icon-overlay-close');
    } else if (localStorage.getItem('ynex-sidemenu-styles') == 'closed') {
      html?.setAttribute(
        'data-toggled',
        html?.getAttribute('data-toggled') == 'close-menu-close'
          ? ''
          : 'close-menu-close'
      );
    } else if (localStorage.getItem('ynex-sidemenu-styles') == 'icontext') {
      html?.setAttribute(
        'data-toggled',
        html?.getAttribute('data-toggled') == 'icon-text-close'
          ? ''
          : 'icon-text-close'
      );
    } else if (localStorage.getItem('ynex-sidemenu-styles') == 'detached') {
      html?.setAttribute(
        'data-toggled',
        html?.getAttribute('data-toggled') == 'detached-close'
          ? ''
          : 'detached-close'
      );
    } else if (localStorage.getItem('ynex-sidemenu-styles') == 'doublemenu') {
      html?.setAttribute(
        'data-toggled',
        html?.getAttribute('data-toggled') == 'double-menu-close'
          ? 'double-menu-open'
          : 'double-menu-close'
      );

      // document.querySelector('.slide-menu')?.classList.add('double-menu-active');
    }

    if (window.innerWidth <= 992) {
      html?.setAttribute(
        'data-toggled',
        html?.getAttribute('data-toggled') == 'open' ? 'close' : 'open'
      );
      if (html?.getAttribute('data-toggled') == 'open') {
        document.querySelector('#responsive-overlay')?.classList.add('active');
      }
    }
  }
  // Search
  public menuItems!: Menu[];
  public items!: Menu[];
  public text!: string;
  public SearchResultEmpty: boolean = false;
  ngOnInit() {
    this.user = JSON.parse(localStorage.getItem('user') as string);
    this.getUserLogData();

    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        map(
          () =>
            this.router.url.split('/')[this.router.url.split('/').length - 1]
        )
      )
      .subscribe((route) => {
        this.currentRoute = route;
      });
    this.navServices.items.subscribe((menuItems) => {
      this.items = menuItems;
    });

    const selectedLanguageCode = this.translationService.currentLang;
    this.selectedLanguage = this.languages.find((l)=>l.code === selectedLanguageCode) as TranslationObj;
  }

  Search(searchText: string) {
    if (!searchText) return (this.menuItems = []);
    // items array which stores the elements
    const items: Item[] = [];
    // Converting the text to lower case by using toLowerCase() and trim() used to remove the spaces from starting and ending
    searchText = searchText.toLowerCase().trim();
    this.items.filter((menuItems: Menu) => {
      // checking whether menuItems having title property, if there was no title property it will return
      if (!menuItems?.title) return false;
      //  checking wheteher menuitems type is text or string and checking the titles of menuitems
      if (
        menuItems.type === 'link' &&
        menuItems.title.toLowerCase().includes(searchText)
      ) {
        // Converting the menuitems title to lowercase and checking whether title is starting with same text of searchText
        if (menuItems.title.toLowerCase().startsWith(searchText)) {
          // If you want to get all the data with matching to letter entered remove this line(condition and leave items.push(menuItems))
          // If both are matching then the code is pushed to items array
          items.push(menuItems as Item);
        }
      }
      //  checking whether the menuItems having children property or not if there was no children the return
      if (!menuItems.children) return false;
      menuItems.children.filter((subItems: Menu) => {
        if (!subItems?.title) return false;
        if (
          subItems.type === 'link' &&
          subItems.title.toLowerCase().includes(searchText)
        ) {
          if (subItems.title.toLowerCase().startsWith(searchText)) {
            // If you want to get all the data with matching to letter entered remove this line(condition and leave items.push(subItems))
            items.push(subItems as Item);
          }
        }
        if (!subItems.children) return false;
        subItems.children.filter((subSubItems: Menu) => {
          if (subSubItems.title?.toLowerCase().includes(searchText)) {
            if (subSubItems.title.toLowerCase().startsWith(searchText)) {
              // If you want to get all the data with matching to letter entered remove this line(condition and leave items.push(subSubItems))
              items.push(subSubItems as Item);
            }
          }
        });
        return true;
      });
      return (this.menuItems = items);
    });
    // Used to show the No search result found box if the length of the items is 0
    if (!items.length) {
      this.SearchResultEmpty = true;
    } else {
      this.SearchResultEmpty = false;
    }
    return true;
  }

  //  Used to clear previous search result
  clearSearch() {
    this.text = '';
    this.menuItems = [];
    this.SearchResultEmpty = false;
    return this.text, this.menuItems;
  }
  isCartEmpty: boolean = false;
  isNotifyEmpty: boolean = false;

  removeRow(rowId: string) {
    const rowElement = document.getElementById(rowId);
    if (rowElement) {
      rowElement.remove();
    }
    this.cartItemCount--;
    this.isCartEmpty = this.cartItemCount === 0;
  }
  removeTags(rowId: string) {
    const rowElement = document.getElementById(rowId);
    if (rowElement) {
      rowElement.remove();
    }
  }
  removeNotify(rowId: string) {
    const rowElement = document.getElementById(rowId);
    if (rowElement) {
      rowElement.remove();
    }
    this.notificationCount--;
    this.isNotifyEmpty = this.notificationCount === 0;
  }
  handleCardClick(event: MouseEvent) {
    // Prevent the click event from propagating to the container
    event.stopPropagation();
  }

  navigateToEposPayments() {
    this.router.navigate(['dashboard/epos-payments']);
  }
  onLogout() {
    this.dialog.open(LogoutDialogComponent, {
      height: '400px',
      width: '350px',
    });
  }
  onResetAgentPinClick() {
    const dialogRef = this.dialog.open(CofirmationDialogComponent, {
      data: {
        title: this.translate.instant('ALERT2.CONFIRMATION.TITLE'),
        text: 'Do you confirm and want to reset agent pin?',
        choices: [
          { label: 'HEADER.RESET_PIN_EMAIL_SMS', value: 'email-sms' },
          { label: 'HEADER.RESET_PIN_WHATSAPP', value: 'whatsapp' },
        ],
      },
    });
    dialogRef.afterClosed().subscribe((result: string | boolean) => {
      if (!result) {
        return;
      }
      // Only WhatsApp adds the channel parameter, EMAIL/SMS keeps the old call.
      this.resetAgentPin(result === 'whatsapp' ? 'whatsapp' : undefined);
    });
  }
  resetAgentPin(channel?: string) {
    this.authService.resetAgentPin(channel).subscribe({
      next: (res: any) => {
        swal(this.translate.instant('ALERT.SUCCESS'), res.message, 'success');
      },
      error: (err: any) => {
        swal(this.translate.instant('ALERT.ERROR'), err.message, 'error');
      },
    });
  }
  openRequestFloatModal(id: any) {
    this.activeTabId = id;
    const dialog = this.dialog.open(RequestFloatTransferComponent, {
      width: '800px',
      height: '450px',
    });
    dialog.afterClosed().subscribe((res) => {
      this.activeTabId = 0;
    });
  }

  getUserLogData() {
    if (localStorage.getItem('user')) {
      const user = JSON.parse(localStorage.getItem('user') as string);
      this.authService.getUserLogData(user?.id).subscribe({
        next: (res: any) => {
          this.userLogData = res;
        },
        error: (err: any) => {},
      });
    }
  }

  openDeveloperKeys() {
    this.balanceSheetService.getTellerKeyDetails().subscribe({
      next: (res) => {
        if (res?.success) {
          const data = {
            defaultKey: res.apiKey,
            userName: `${res.userFirstName || ''} ${
              res.userLastName || ''
            }`.trim(),
            roles: ['PARTNER'],
            expiration: new Date(res.partnerApiExpiryTime),
            partnerSymetricAlg: res.partnerSymetricAlg,
            apiKeys: [
              {
                name: 'API User',
                type: 'Partner API User',
                value: res.apiUser,
                allowReset: false,
              },
              {
                name: 'API Key',
                type: 'Partner API Key',
                value: res.apiKey,
                allowReset: true,
              },
              {
                name: 'Teller Secret Key',
                type: 'Body Key',
                value: res.tellerSecretKey,
                allowReset: false,
              },
              {
                name: 'Public Key',
                type: 'Token Verification Key',
                value: res.encPublicKey,
                allowReset: false,
              },
              {
                name: '',
                type: 'Last PK Generation date : ',
                value: new Date(res.encKeyGenDate),
                allowReset: false,
              },
            ],
          };

          this.dialog.open(DeveloperKeysComponent, {
            width: '900px',
            maxHeight: '80vh',
            data,
            panelClass: 'custom-dialog-container',
          });
        } else {
          swal(
            'Failed',
            res?.message || this.translate.instant('ALERT.FETCH_API.UNABLE'),
            'error'
          );
        }
      },
      error: (err) => {
        swal(
          this.translate.instant('ALERT.ERROR'),
          err?.message || this.translate.instant('ALERT.FETCH_API.ERROR'),
          'error'
        );
      },
    });
  }

  onLangChange(lang:TranslationObj){
    this.translationService.useLang(lang.code);
    this.selectedLanguage = lang;
  }
}
